import { render } from "./SystemSetting.vue?vue&type=template&id=606430a3&scoped=true"
import script from "./SystemSetting.vue?vue&type=script&lang=js"
export * from "./SystemSetting.vue?vue&type=script&lang=js"

import "./SystemSetting.vue?vue&type=style&index=0&id=606430a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606430a3"]])

export default __exports__